module.exports = __webpack_public_path__ + "static/media/chaca2.c45b4829.JPG";